import type { TenantStatus, JobStatus } from '../api/types';

const STATUS_LABEL: Record<TenantStatus, string> = {
  active: '活跃',
  grace: '宽限期',
  read_only: '只读',
  suspended: '已停服',
  manually_locked: '手动冻结',
  terminated: '已清退',
  provisioning: '开通中',
};

const STATUS_CLASS: Record<TenantStatus, string> = {
  active: 'badge--active',
  grace: 'badge--grace',
  read_only: 'badge--read_only',
  suspended: 'badge--suspended',
  manually_locked: 'badge--manually_locked',
  terminated: 'badge--terminated',
  provisioning: 'badge--provisioning',
};

interface StatusBadgeProps {
  status: TenantStatus;
}

export function TenantStatusBadge({ status }: StatusBadgeProps) {
  return (
    <span className={`badge ${STATUS_CLASS[status] ?? 'badge--terminated'}`}>
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}

const JOB_LABEL: Record<JobStatus, string> = {
  succeeded: '成功',
  running: '运行中',
  pending: '排队中',
  failed: '失败',
};

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return <span className={`badge badge--${status}`}>{JOB_LABEL[status]}</span>;
}
